import React from "react";
import { ArrowRightAlt } from "mosaic-react-icons";
const SeparatorArrow = () => {
    return <ArrowRightAlt fontSize={"large"} />;
};

export default SeparatorArrow;